// extracted by mini-css-extract-plugin
module.exports = {"dialog":"ContactPersonModal_dialog__38GlE","input":"ContactPersonModal_input__2rlg4","error":"ContactPersonModal_error__bd-PI"};